import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { api } from "utils/Api";
import { showWarning, showSuccess } from "utils/messageAlerts";

function ChangePasswordPopup({ onClose }) {
  const [loading, setLoading] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Show/Hide states
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      showWarning("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      showWarning("New password and confirm password do not match");
      return;
    }

    if (newPassword.length < 5) {
      showWarning("Password must be at least 5 characters");
      return;
    }

    setLoading(true);

    try {
     const response = await api.forgotPassword.putPasswordChange({
        old_password: oldPassword,
        new_password: newPassword,
      });

      showSuccess(response.message || "Password changed successfully.");
      onClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordField = (label, value, setValue, show, setShow, placeholder) => (
    <SoftBox>
      <SoftTypography variant="caption" fontWeight="bold">
        {label}{" "}
        <Box component="span" color="error.main">
          *
        </Box>
      </SoftTypography>

      <SoftInput
        type={show ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        icon={{
          component: (
            <IconButton size="small" onClick={() => setShow(!show)} sx={{ padding: "4px" }}>
              {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
          direction: "right",
        }}
      />
    </SoftBox>
  );

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Change Password</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

            {renderPasswordField(
              "Old Password",
              oldPassword,
              setOldPassword,
              showOld,
              setShowOld,
              "Enter old password"
            )}

            {renderPasswordField(
              "New Password",
              newPassword,
              setNewPassword,
              showNew,
              setShowNew,
              "Enter new password"
            )}

            {renderPasswordField(
              "Confirm Password",
              confirmPassword,
              setConfirmPassword,
              showConfirm,
              setShowConfirm,
              "Confirm new password"
            )}

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Updating..." : "Update Password"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

ChangePasswordPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ChangePasswordPopup;